import React from "react";
import "./Values.css"; // you’ll create this file
import { Link } from "react-router-dom";
import { Button } from "./Button";

function ValuesSection() {
  return (
    <div className="values-section">
      <div className="values-header">
        <h1>Our Values</h1>
        <p>
          At Fenix Media, every project is guided by principles that define who
          we are and how we work.
        </p>
      </div>

      <div className="values-list">
        <div className="value-item">
          <h2>Client-First</h2>
          <p>
            Your success is our priority. We listen, adapt, and work closely
            with you to bring your vision to life.
          </p>
        </div>
        <div className="value-item">
          <h2>Always Learning</h2>
          <p>
            We approach every challenge with curiosity and humility. By staying
            open to new ideas and technologies, we keep growing and so do our
            clients’ results.
          </p>
        </div>

        <div className="value-item">
          <h2>Transparent</h2>
          <p>
            What you see is what you get clear strategies, realistic
            expectations, and authentic results.
          </p>
        </div>

        <div className="value-item">
          <h2>Creative</h2>
          <p>
            Creative, persistent, and tenacious, we approach each project with a
            business mindset.
          </p>
        </div>

        <div className="value-item">
          <h2>Flexible</h2>
          <p>
            We embracing growth and innovation while staying true to our core
            purpose, we deliver consistency in any environment.
          </p>
        </div>

        <div className="value-item">
          <h2>Detail-Oriented</h2>
          <p>
            We take a meticulous approach holding ourselves to the highest
            standards.
          </p>
        </div>
      </div>
      <div className="buttons">
        <Link to="/portfolio">
          <Button
            className="btn-primary"
            buttonStyle="btn--primary"
            buttonSize="btn--large"
          >
            Explore the Portfolio{" "}
          </Button>
        </Link>
      </div>
    </div>
  );
}

export default ValuesSection;
